export function xtractAPI(resource, method, obj, callbacks = {}, config = {}) {
  if (this && this.windowConfig && this.windowConfig.ref) {
    config.windowRef = this.windowConfig.ref
  }
  return {
    type: 'XTRACT_API_CALL',
    resource,
    method,
    obj,
    callbacks,
    config
  }
}

export function cancelPendingAPICallbacks(windowConfig) {
  let ref
  if (windowConfig && windowConfig.ref) {
    ref = windowConfig.ref
  }
  return {
    type: 'CANCEL_PENDING_API_CALLBACKS',
    ref
  }
}

export function reportDownload(
  resource,
  filename,
  callbacks = {},
  config = {}
) {
  return fileDownload(resource, filename, callbacks, config)
}

export function fileDownload(resource, filename, callbacks = {}, config = {}) {
  return {
    type: 'XTRACT_FILE_DOWNLOAD',
    resource,
    filename,
    callbacks,
    config
  }
}

export function callbackWrapper(callback, args) {
  return {
    type: 'EXECUTE_API_CALLBACK',
    callback,
    args
  }
}

export function closeStream(name) {
  return {
    type: 'CLOSE_STREAM',
    name
  }
}
